<div>
    <!-- <div [ngStyle]="{'padding-top':'10px', 'max-height':'67px'}">
        <mat-form-field>
            <mat-radio-group>
                <mat-select placeholder="Pendentes" [(ngModel)]="filtroStatus">
                    <mat-option [value]="1">Pendentes</mat-option>
                    <mat-option [value]="2">Realizadas</mat-option>
                    <mat-option [value]="3">Não Realizadas</mat-option>
                </mat-select>
            </mat-radio-group>
        </mat-form-field>
    </div> -->

    <!-- <div [ngClass]="['filterPage__filtroUser']">
        <div class="filterPage__titles">
            <span>Por Usuários</span>
            <mat-checkbox class="checkboxFD" [(ngModel)]="checkboxSelected" (change)="selectAll()"><span>Selecionar todos</span></mat-checkbox>
        </div>
        <div [ngClass]="['filterPage__filtroUser-users']">
            <div *ngFor="let user of listaUsuarios" (click)="filterUserSelect(user)" [ngStyle]="{'margin-bottom':'4px'}" [matTooltip]="user ? user.nome : ''">
                <img [src]="user.img" onError="this.src='assets/img/usuarioAnonimo.png'">
                <div [ngClass]="['filterPage__filtroUser-users-selected']" *ngIf="user.selected || user.selectedDefault"></div>
            </div>
        </div>
    </div> -->

    <div>
        <div class="expansion-filter" (click)="filtroUsuarioExpandido = !filtroUsuarioExpandido"
            *ngIf="(listaUsuarios?.length)">
            <span class="subtitle-medium">
                Usuários
            </span>
            <mat-icon mat-list-icon [svgIcon]="'menu-up'" [@animationRotate]="filtroUsuarioExpandido ? 'open' : 'close'"
                class="icon-expansion"></mat-icon>
        </div>
        <div class="container-filter" [@animationShowHide]="filtroUsuarioExpandido ? 'open' : 'close'"
            *ngIf="(listaUsuarios?.length)">
            <div class="item-filter">
                <div class="all-users">
                    <span class="paragraph-regular">TODOS</span>
                    <mat-checkbox [(ngModel)]="checkboxSelected" (change)="selectAll()"></mat-checkbox>
                </div>
            </div>

            <div class="item-filter" *ngIf="listaUsuarios?.length">
                <span class="paragraph-regular-xs color-sub-title">Ativos</span>
                <div class="lista"
                    [ngClass]="[listaUsuarios && listaUsuarios.length > 8 ? 'overflow-lista' : '' ]">
                    <div class="item" *ngFor="let usuario of listaUsuarios">
                        <div class="container-nome">
                            <img [src]="usuario.img" onError="this.src='assets/img/usuarioAnonimo.png'">
                            <span>{{usuario.nome}}</span>
                        </div>
                        <mat-checkbox (change)="filterUserSelect(usuario)"
                            [ngModel]="usuario.selected || usuario.selectedDefault" (ngModelChange)="usuario.selected || (usuario.selectedDefault = $event)"></mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="actionButtonsFiltros">
        <button mat-button class="btn-limpar-filtro" (click)="clearFilter()">LIMPAR FILTROS</button>
        <button mat-raised-button class="btn-filtro" (click)="buildString()">APLICAR</button>
    </div>
</div>